import { IconLockAccessOff } from "@tabler/icons-react"
import Logo from "../../assets/images/paqtory.png"
import { Link } from "react-router-dom"

import { IconBrandFacebook, IconBrandLinkedin, IconBrandInstagram, IconBrandYoutube, IconBrandTwitter } from "@tabler/icons-react"
import { useSelector } from 'react-redux';

import { useNavigate } from "react-router-dom"

function MainUnauthorizedComponent({primaryAction = { label: "Go to Dashboard", onClick: () => { } }, secondaryAction = { label: "Contact Support", onClick: () => { } } }) {

  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const role = user?.role || user?.roles || user?.user_account_type;

  let message =  "You don't have permission to access this page. Please contact your administrator if you believe this is an error.";
  let title = "Access Denied";
  let label = role === "admin" ? "Go to Dashboard" : "Go to Home";
  primaryAction ={ label: label, onClick: () => { } };

 
  const handlePrimaryAction = () => {
    if (role === 'customer') {
      navigate("/"); // Redirect to home page for customers
    } else if (role === 'super_admin' || role === 'manager' || role === 'editor') {
      navigate("/admin"); // Redirect to admin dashboard for admins
    }
  }
  const handleSecondaryAction = () => {
    navigate("/contactus");
  }

  return (
    <main className="flex-1 flex items-center justify-center px-4 ">
      <div className="max-w-5xl w-full flex flex-col lg:flex-row items-center justify-center gap-8">
        <div className="lg:w flex justify-center">
          <div className="max-w-sm w-full bg-white rounded-md border border-[#FFD500]/30 p-6 text-center" style={{ boxShadow: "0 0 0 2px #FFD500" }}>
            <div className="flex justify-center mb-4">
              <IconLockAccessOff size={48} className="text-red-500" />
            </div>
            <h2 className="text-2xl font-bold mb-2 text-[#0B0C52]">{title}</h2>
            <p className="text-gray-600 mb-6">{message}</p>

            <div className="space-y-4">
              <button
                className="bg-[#0B0C52] text-white w-full py-2 rounded font-semibold hover:opacity-90"
                onClick={handlePrimaryAction}
              >
                {primaryAction.label}
              </button>
              <button
                className="border border-[#0B0C52] text-[#0B0C52] w-full py-2 rounded font-semibold hover:bg-gray-100"
                onClick={handleSecondaryAction}
              >
                {secondaryAction.label}
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default function AccessDenied(isFullPage = false) {

  isFullPage = isFullPage.isFullPage || false; // Check if isFullPage is passed as a prop

  if (!isFullPage) {
    return (
      <div className="min-h-screen flex flex-col bg-[#F9F9FF]">
        <MainUnauthorizedComponent />
      </div>
    )
  }
  return (
    <div className="min-h-screen flex flex-col bg-[#F9F9FF]">
      <header className="h-16 bg-[#0B0C52] flex items-center justify-between px-4 md:px-8 text-white">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <div className="w-10 h-10 rounded-full bg-[#FFD500] flex items-center justify-center overflow-hidden">
              <img
                src={Logo}
                alt="Logo"
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <span className="ml-2 text-sm font-semibold">Company Name</span>
          </Link>
        </div>
        <div>
          <button className="border border-white px-3 py-1 rounded-md text-sm flex items-center gap-1 hover:bg-white hover:text-[#0B0C52] transition-colors">
            English <span className="text-xs">&#x25BE;</span>
          </button>
        </div>
      </header>

      <MainUnauthorizedComponent />
      <footer className="bg-[#0B0C52] border-t border-gray-200 py-6">
        <div className="max-w-5xl mx-auto px-4 flex flex-col items-center space-y-3 text-white">
          <div className="flex flex-wrap justify-center space-x-4 text-sm">
            <a href="#about" className="hover:underline">About Us</a>
            <span>|</span>
            <a href="#terms" className="hover:underline">Terms & Conditions</a>
            <span>|</span>
            <a href="#privacy" className="hover:underline">Privacy Policy</a>
            <span>|</span>
            <a href="#contact" className="hover:underline">Contact Us</a>
            <span>|</span>
            <a href="#faq" className="hover:underline">FAQ</a>
          </div>
          <div className="flex space-x-3">
            <SocialIcon href="#facebook">
              <IconBrandFacebook size={18} />
            </SocialIcon>
            <SocialIcon href="#twitter">
              <IconBrandTwitter size={18} />
            </SocialIcon>
            <SocialIcon href="#linkedin">
              <IconBrandLinkedin size={18} />
            </SocialIcon>
            <SocialIcon href="#instagram">
              <IconBrandInstagram size={18} />
            </SocialIcon>
            <SocialIcon href="#youtube">
              <IconBrandYoutube size={18} />
            </SocialIcon>
          </div>
          <p className="text-sm text-gray-400">© 2025 Company Name. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  )
}

// Reuse the same SocialIcon component
function SocialIcon({ href, children }) {
  return (
    <a
      href={href}
      className="w-8 h-8 bg-white border border-[#0B0C52] rounded flex items-center justify-center text-[#0B0C52] hover:bg-[#0B0C52] hover:text-white transition"
    >
      {children}
    </a>
  )
}